import { z } from 'zod';

export const onboardingTourNames = [
  'InstallExtension',
  'TakeAction',
  'SetupProfile',
  'InviteTeamMembers',
  'SetUpIntegrations',
  'CreateYourFirstCampaign',
] as const;

export type OnboardingTourName = (typeof onboardingTourNames)[number];
export type OnboardingTourStatusMap = Partial<Record<OnboardingTourName, boolean>>;

export const onboardingTourNameSchema = z.enum(onboardingTourNames);
export const onboardingTourNameEnum = onboardingTourNameSchema.enum;

export const optionalTourNames: OnboardingTourName[] = [
  onboardingTourNameEnum.InviteTeamMembers,
  onboardingTourNameEnum.SetUpIntegrations,
  onboardingTourNameEnum.CreateYourFirstCampaign,
];

export const dataOnboardingIds = {
  settingsTrigger: 'settings-trigger',
  profileForm: 'profile-form',
  openTeamSettings: 'open-team-settings',
  inviteMembersTrigger: 'invite-members-trigger',
  integrationsHeader: 'integrations-header',
  automationLimits: 'automation-limits',
  emailIntegration: 'email-integration',
  defaultStages: 'default-stages',
  campaignTemplatesTrigger: 'campaigns-templates-trigger',
  addCampaignTrigger: 'add-campaign-trigger', // remove
  addCampaignForm: 'add-campaign-form', // remove
  addCampaignSubmitButton: 'add-campaign-submit-button', // remove
  addCampaignStepTrigger: 'add-campaign-step-trigger', // remove
  addCampaignStepForm: 'add-campaign-step-form', // remove
  addCampaignStepConfirmButton: 'add-campaign-step-confirm-button', // remove
  addCampaignCardDelay: 'add-campaign-card-delay',
  addCampaignCardDelayConfirm: 'add-campaign-card-delay-confirm', // remove

  cadenceTemplateCard: 'cadence-template-card',
  cadenceTemplateStep: 'cadence-template-step',
  runCampaignButton: 'run-campaign-button',
  takeActionContacts: 'take-action-contacts',
  takeActionContactsTrigger: 'take-action-contacts-trigger',
};
